var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',[_c('div',{staticClass:"w-full flex-col shadow-md pb-2 mb-4 bg-white rounded mr-8"},[_vm._m(0),_vm._v(" "),_vm._t("default")],2)])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex border-b-2 border-followup-nav text-grey-darkest rounded-t p-2 justify-between"},[_c('span',{staticClass:"pl-2"},[_vm._v("Contact Analytics")])])
}]

export { render, staticRenderFns }